import { render } from "./megan.vue?vue&type=template&id=015fd1cf&ts=true"
import script from "./megan.vue?vue&type=script&lang=ts"
export * from "./megan.vue?vue&type=script&lang=ts"

import "./megan.vue?vue&type=style&index=0&id=015fd1cf&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__